const breakpoints = {
  large: 768,
  xlarge: 1024,
}

export default {
  data() {
    return {
      width: window.innerWidth,
    }
  },
  computed: {
    large() {
      return this.width >= breakpoints.large
    },
  },

  mounted() {
    window.addEventListener('resize', this.setWidth)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setWidth)
  },

  methods: {
    setWidth() {
      this.width = window.innerWidth
    },
  },
}



// WEBPACK FOOTER //
// ./src/utils/mixins/windowWidth.js